export const ADD_TO_BASKET = 'ADD_TO_BASKET';
export const REMOVE_FROM_BASKET = 'REMOVE_FROM_BASKET';
export const UPDATE_QUANTITY = 'UPDATE_QUANTITY';
